import { createFileRoute } from '@tanstack/react-router'
import CostTypes from 'Administration/components/configuration/costtypes/CostTypes'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/costtypes')({
    component: () => (
        <Guard claims={['opus_user']}>
            <AdministrationPage>
                <CostTypes />
            </AdministrationPage>
        </Guard>
    ),
})
